import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import { GlgPopup } from 'SharedComponents'
import EditCategoryComponentSimGolf from '../edit_category_component_sim_golf'

const AddEditCategoryPopupSimGolf = ({
  setDisplayPopup,
  displayPopup,
  deleteCategory,
  title,
  categories,
  displayDeletePopup,
  setDisplayDeletePopup,
  name,
  updateCategoriesSimGolf,
  addNew,
  customerId,
  updateURL,
}) => {
  const [allCategoriesData, setAllCategoriesData] = useState(categories)

  const handleClose = () => {
    setDisplayPopup(false)
  }

  return (
    <GlgPopup
      modalClass='add_edit_category_popup general_sim_golf_popup'
      title={ title || '' }
      show={ displayPopup }
      onClose={ handleClose }
      onSave={ updateCategoriesSimGolf }
      saveButtonEnabled={
        Object.keys(allCategoriesData).length > 0 &&
        Object.values(allCategoriesData).every(category => category.name != '')
      }
      saveButtonText={ window.I18n.t('customer_center_comp.components.sim_golf_buttons.save') }
      closeButtonText={ window.I18n.t('customer_center_comp.components.sim_golf_buttons.cancel') }
      data={ allCategoriesData }
      formUrl={ updateURL }
    >
      <p className='popup_body_title'>{ window.I18n.t('customer_center_comp.components.sim_golf_labels.drag_and_drop') }</p>
      <EditCategoryComponentSimGolf
        categories={ categories }
        displayDeletePopup={ displayDeletePopup }
        setDisplayDeletePopup={ setDisplayDeletePopup }
        name={ name }
        deleteCategory={ deleteCategory }
        setAllCategoriesData={ setAllCategoriesData }
        addNew={ addNew }
        customerId={ customerId }
        setDisplayPopup={ setDisplayPopup}
      />
    </GlgPopup>
  )
}

AddEditCategoryPopupSimGolf.propTypes = {
  displayPopup: PropTypes.bool.isRequired,
  setDisplayPopup: PropTypes.func.isRequired,
  deleteCategory: PropTypes.func.isRequired,
  updateCategoriesSimGolf: PropTypes.func.isRequired,
  customerId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  categories: PropTypes.object.isRequired,
  displayDeletePopup: PropTypes.bool.isRequired,
  setDisplayDeletePopup: PropTypes.func.isRequired,
  name: PropTypes.string,
  addNew: PropTypes.bool,
  updateURL: PropTypes.string,
}

export default AddEditCategoryPopupSimGolf